import { render, staticRenderFns } from "./deleteModal.vue?vue&type=template&id=5f9e07f0&"
import script from "./deleteModal.vue?vue&type=script&lang=js&"
export * from "./deleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports